import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import NotaCreditoFactura from './NotaCreditoFactura';
import NotaCreditoFacturas from './NotaCreditoFacturas';
// import PDFViewer from "pdf-viewer-reactjs";
import PDFViewer from '../../../components/pdfViewer'
import { objectAsParams } from '../../../helpers';
import ACCESS from '../../../ACCESS';

class NotaCredito extends FormComponent {

  state = {
    editFactura: false,
    notaCredito: {},
  }

  constructor() {
    super();
    this.childTable = React.createRef();
  }


  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'nota-credito/one', saveUrl: 'nota-credito/save', backUrl: '/cobranza/notas-credito' },
      new Form([
        Form.Field('autocomplete', 'id_cliente', 'Cliente', '', [Validators.required], 12),
        Form.Field('select', 'id_concepto_credito', 'Tipo', '', [Validators.required], 4),
        Form.Field('select', 'credito_contado', 'Tipo de factura', '', [Validators.required], 3, [
          { Label: 'Contado', Value: 1 },
          { Label: 'Crédito', Value: 2 },
        ]),
        Form.Field('number', 'importe', 'Importe', '', [Validators.required], 5),
        Form.Field('textarea', 'descripcion', 'Descripción', '', [Validators.required], 12),
        Form.Field("select", "id_cfdi_uso", "Uso CFDI", "", [Validators.required], 4),
        Form.Field("select", "id_forma_pago", "Forma de pago", "", [Validators.required], 4),
        Form.Field("select", "id_metodo_pago", "Metodo de pago", "", [Validators.required], 4),
      ], ['Guardar', 'Agregar factura'], 'Nota de crédito'), this.formData
    )
    this.loadPredData();
  }

  loadPredData = async () => {
    if (this.props.match.params.id) {
      const predData = await this.LoadPreds()
      this.setState({ notaCredito: predData, disabled: predData.timbrado });
      this.formCliId = predData.id_cliente;
      this.setState({ FormData: await this.formData() });
      // setTimeout(() => {
      //   this.formData();
      // }, 1000);
    }
  }

  formData = async (form) => {
    if (!form) form = this.state.FormData;
    const params = {};
    let newForm = form;
    if (this.formCli) {
      params["cli"] = this.formCli;
      this.formCli = null;
    }
    if (this.formCliId) {
      params["c"] = this.formCliId;
    }

    const Res = await Http.get(`nota-credito/form?${objectAsParams(params)}`);
    console.log(Res);
    if (!Res.error) {
      const { conceptos, clientes, cfdi_usos, formas_pago, metodos_pago } = Res.data;
      newForm = Form.FieldOptions(newForm, 'id_concepto_credito', conceptos, 'id', 'concepto_credito');
      if (clientes) newForm = Form.FieldOptions(newForm, 'id_cliente', clientes, 'id', 'cliente_rsocial');
      if (cfdi_usos) newForm = Form.FieldOptions(newForm, "id_cfdi_uso", cfdi_usos, "id", "cfdi_uso_nombre");
      if (formas_pago) newForm = Form.FieldOptions(newForm, "id_forma_pago", formas_pago, "id", "forma_nombre");
      if (metodos_pago) newForm = Form.FieldOptions(newForm, "id_metodo_pago", metodos_pago, "id", "metodo_nombre");
    }
    if (this.formCliId) {
      newForm = Form.Patch(newForm, { id_cliente: this.formCliId + '' });
      this.formCliId = null;
    }
    newForm = Form.ValueChange(newForm, {
      id_cliente: async (field) => { (field.ValueAt && field.ValueAt.length > 2) && this.clienteChange(field, 'formCli') },
    });
    return newForm;
  }

  clienteChange = async (field, variable) => {
    // console.log(field)
    if (field.Value && !isNaN(field.Value)) {
      this.getCliente(field.Value);
    }
    else {
      this[variable] = field.ValueAt;
      this.setState({ FormData: await this.formData(this.state.FormData) });
    }
  }

  getCliente = async (id) => {
    try {
      let res = await Http.get(`cliente/one/${id}`);
      if (!res.error) {
        const { cliente_cfdi_uso, cliente_forma_pago, cliente_metodo_pago } = res.data;
        let formData = this.state.FormData;
        formData = Form.Patch(formData, { id_cfdi_uso: cliente_cfdi_uso, id_forma_pago: cliente_forma_pago, id_metodo_pago: cliente_metodo_pago }, false);
        this.setState({ FormData: formData });
      }
    } catch (error) {

    }
  }

  onSubmit = async (button, vals) => {
    if (button === 1) {
      this.setState({ loading: true });
      vals.id = this.props.match.params.id || null;
      var Res = await Http.post(`${this.config.saveUrl}`, vals);
      if (!Res.error) {
        this.setState({ notaCredito: Res.data });
        this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true });
        this.props.history.push(`/cobranza/nota-credito/${Res.data.id}`)
      }
      else {
        this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });
      }
    }
    else if (button === 2) {
      if (!this.props.match.params.id) return this.setState({ sbMsg: 'Guardar factura antes', sbOpen: true });
      this.setState({ editFactura: true })
    }
  }

  onFacturaClose = () => {
    this.setState({ editFactura: false });
  }

  onFacturaSave = () => {
    this.setState({ editFactura: false });
    this.setState({ reloadTable: this.state.reloadTable ? this.state.reloadTable + 1 : 1 });
    this.loadPredData();
  }

  onFacturaEdited = () => {
    this.loadPredData();
  }

  onTimbrar = async () => {
    this.setState({ loading: true });
    if (this.state.notaCredito?.restante > 5) return this.setState({ sbMsg: 'Aún hay restante', sbOpen: true })
    const Resp = await Http.post(`nota-credito/timbrar`, { id: this.props.match.params.id }, true, "arraybuffer")
    let response = null;
    try {
      let decodedString = String.fromCharCode.apply(null, new Uint8Array(Resp));
      response = JSON.parse(decodedString);
    } catch (error) {
      console.log(error);
    }
    if (response && response.error) {
      this.setState({ loading: false, sbOpen: true, sbMsg: response.errMsg });
    } else {
      const blob = new Blob([Resp], { type: "application/pdf" });
      this.setState({
        pdfURL: URL.createObjectURL(blob),
        viewPdf: true,
        loading: false,
        notaCredito: { ...this.state.notaCredito, timbrado: 1 }
      });
    }
  }

  handledownloadPdf = () => {
    const { pdfURL } = this.state;
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = pdfURL;
    a.download = `factura.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(pdfURL);
  }

  handledownloadFile = async () => {
    const Resp = await Http.post("nota-credito/file", { id_nota_credito: this.props.match.params.id }, true, "arraybuffer");
    if (Resp) {
      const blob = new Blob([Resp], { type: "application/xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `Timbrado.xml`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }

  viewPdfClose = () => {
    this.setState({ viewPdf: false });
  };

  render() {
    const { editFactura, notaCredito, reloadTable = 0, viewPdf = false, pdfURL, loading } = this.state;
    const { hasAccess } = this.context;
    return (
      <div style={{ backgroundColor: 'white' }}>
        {
          notaCredito.timbrado && (
            <div style={{ textAlign: 'right', padding: 10 }}>
              <p><b>Folio fiscal:</b> {notaCredito.fiscal}</p>
            </div>
          )
        }
        <this.FormRender />

        {
          this.props.match.params.id && (
            <div>
              <div style={{ textAlign: 'right', paddingRight: 10 }}>
                {!notaCredito.timbrado && hasAccess(ACCESS.COBRANZA_NOTA_CREDITO.TIMBRAR_NOTA_DE_CREDITO) &&
                  <Button
                    variant="contained"
                    color='primary'
                    onClick={this.onTimbrar}
                    disabled={(notaCredito.restante > 5 || notaCredito.restante < -5) || loading || notaCredito.timbrado}>
                    Timbrar
                  </Button>
                }
                <h4 style={{ margin: 0 }}>Restante: {notaCredito.restante}</h4>
                <h4 style={{ margin: 0 }}>Suma: {(notaCredito.total - notaCredito.restante).toFixed(2) || ''}</h4>
              </div>
              <NotaCreditoFacturas
                reloadCount={reloadTable}
                notaCreditoId={this.props.match.params.id || null}
                notaCredito={notaCredito}
                onEdited={this.onFacturaEdited}
              />
            </div>
          )
        }

        <Dialog
          onClose={this.onFacturaClose}
          open={editFactura}
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogTitle onClose={this.onFacturaClose}>Factura</DialogTitle>
          <DialogContent dividers>
            <NotaCreditoFactura
              notaCredito={notaCredito}
              onSave={this.onFacturaSave}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onFacturaClose}>Cerrar</Button>
          </DialogActions>
        </Dialog>




        <Dialog
          onClose={this.viewPdfClose}
          open={viewPdf || false}
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogTitle onClose={this.viewPdfClose}>Vista Previa</DialogTitle>
          <DialogContent dividers>
            {pdfURL !== "" && (
              <div className="pdf-viewer">
                <PDFViewer
                  scale={1}
                  style={{ height: 400 }}
                  document={{
                    url: pdfURL,
                  }}
                  pdfUrl={pdfURL}
                />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.viewPdfClose}>CANCELAR</Button>
            <Button
              variant="contained"
              onClick={this.handledownloadPdf}
            >
              Descargar PDF
            </Button>
            <Button
              variant="contained"
              onClick={() => this.handledownloadFile()}
            >
              Descargar XML Timbrado
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default withRouter(NotaCredito)
